import { Box, Grid, Paper, Typography } from '@material-ui/core';

const ProjectCard = ({
  title,
  description,
  imageSrc,
  imageAlt,
  isRtl = false,
  imageOnLeft = true,
  className = '',
}) => {
  const imageOrder = isRtl
    ? imageOnLeft
      ? 'order-2'
      : 'order-1'
    : imageOnLeft
    ? 'order-2'
    : 'order-1';
  const contentOrder = isRtl
    ? imageOnLeft
      ? 'order-1'
      : 'order-2'
    : imageOnLeft
    ? 'order-1'
    : 'order-2';

  return (
    <Paper
      className={`p-4 !bg-[#F8F8F8] shadow-lg transition-shadow hover:shadow-xl sm:max-w-[60vw] m-auto ${className}`}
      elevation={0}
    >
      <span className="flex flex-col sm:flex-row items-center gap-12 sm:pl-12">
        <span className={contentOrder}>
          <Typography
            variant="h5"
            component="h3"
            className={`!mb-4 !font-bold ${isRtl ? 'text-right' : 'text-left'}`}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            className={`leading-relaxed !text-sm ${isRtl ? 'text-right' : 'text-left'}`}
          >
            {description}
          </Typography>
        </span>
        <span className={imageOrder}>
          <img
            src={imageSrc}
            alt={imageAlt}
            className="max-w-full max-h-[400px] min-w-[300px] w-auto h-auto rounded-md shadow-md object-contain"
          />
        </span>
      </span>
    </Paper>
  );
};

export default ProjectCard;
